declare namespace $ {

	export class $rise_drag_absolute extends $rise_drag_view {
		top( next?: number ): number
		left( next?: number ): number
		top_px( ): string
		left_px( ): string
		y( next?: ReturnType< $rise_drag_absolute['top'] > ): ReturnType< $rise_drag_absolute['top'] >
		x( next?: ReturnType< $rise_drag_absolute['left'] > ): ReturnType< $rise_drag_absolute['left'] >
		style( ): ({ 
			'position': string,
			'top': ReturnType< $rise_drag_absolute['top_px'] >,
			'left': ReturnType< $rise_drag_absolute['left_px'] >,
		})  & ReturnType< $rise_drag_view['style'] >
	}
	
}

//# sourceMappingURL=absolute.view.tree.d.ts.map